export default function () {
  return [
    {
      title: {
        pl: 'Strona główna',
        en: 'Homepage',
        de: 'Startseite',
        fr: 'Accueil',
        it: 'Pagina iniziale',
      },
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: '',
      permission: 'home'
    },
    {
      title: {
        pl: 'Zamówienia',
        en: 'Orders',
        de: 'Bestellungen',
        fr: 'Commandes',
        it: 'Ordini',
      },
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permission: 'orders'
    },
    {
      title: {
        pl: 'Oferty',
        en: 'Offers',
        de: 'Angebote',
        fr: 'Offres',
        it: 'Offerte',
      },
      to: '/oferty',
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: '',
      permission: 'orders'
    },
    {
      title: {
        pl: 'Klienci',
        en: 'Customers',
        de: 'Kunden',
        fr: 'Clients',
        it: 'Clienti',
      },
      to: '/klienci',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      permission: 'partner_customers'
    },
    {
      title: {
        pl: 'Rozliczenia',
        en: 'Settlements',
        de: 'Abrechnungen',
        fr: 'Facturation',
        it: 'Fatturazione',
      },
      to: '/rozliczenia',
      htmlBefore: '<i class="material-icons">attach_money</i>',
      htmlAfter: '',
      permission: 'settlements'
    },
    {
      title: {
        pl: 'Cenniki',
        en: 'Prices',
        de: 'Preislisten',
        fr: 'Tarifs',
        it: 'Listini prezzi',
      },
      htmlBefore: '<i class="material-icons">monetization_on</i>',
      htmlAfter: '',
      permission: 'partner_users',
      items: [
        {
          title: {
            pl: 'Cenniki produktów',
            en: 'Products prices',
            de: 'Produktpreislisten',
            fr: 'Tarifs des produits',
            it: 'Listini prodotti',
          },
          to: '/cenniki/produkty'
        },
        {
          title: {
            pl: 'Cenniki zdobień',
            en: 'Services prices',
            de: 'Veredelungspreislisten',
            fr: 'Tarifs des marquages',
            it: 'Listini personalizzazioni',
          },
          to: '/cenniki/zdobienia'
        },
        {
          title: {
            pl: 'Cenniki setup',
            en: 'Setup prices',
            de: 'Setup-Preislisten',
            fr: 'Tarifs de setup',
            it: 'Listini setup',
          },
          to: '/cenniki/setup'
        }
      ]
    },
    {
      title: {
        pl: 'Użytkownicy',
        en: 'Users',
        de: 'Benutzer',
        fr: 'Utilisateurs',
        it: 'Utenti',
      },
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">person</i>',
      htmlAfter: '',
      permission: 'partner_users'
    },
    {
      title: {
        pl: 'Twoje konto',
        en: 'Your account',
        de: 'Ihr Konto',
        fr: 'Votre compte',
        it: 'Tuo account',
      },
      to: '/moje-konto',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permission: 'profile'
    },
    {
      title: {
        pl: 'Tłumaczenia',
        en: 'Translations',
        de: 'Übersetzungen',
        fr: 'Traductions',
        it: 'Traduzioni',
      },
      to: '/tlumaczenia',
      htmlBefore: '<i class="material-icons">language</i>',
      htmlAfter: '',
      permission: 'settings'
    },
    {
      title: {
        pl: 'Wyloguj się',
        en: 'Logout',
        de: 'Abmelden',
        fr: 'Se déconnecter',
        it: 'Disconnettersi',
      },
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj',
      permission: false
    }
  ];
}
